<script setup lang="ts">
import { AvatarFallback, AvatarImage, AvatarRoot } from 'reka-ui'
import type { HTMLAttributes } from 'vue'
import { NuxtImg } from '#components'

const props = defineProps<{
  class?: HTMLAttributes['class']
  image?: string
  fallbackName?: string
  fallbackDelay?: number
}>()

const makeFallbackTitle = (name: string) => {
  const nameParts = name.trim().split(/\s+/).slice(0, 2)

  const initials = nameParts
    .filter((part) => part)
    .map((part) => part?.[0]?.toUpperCase())

  return initials.join('')
}
</script>

<template>
  <AvatarRoot
    :class="
      cn(
        'bg-outline text-on-primary inline-flex h-11.25 w-11.25 select-none items-center justify-center overflow-hidden rounded-full align-middle text-sm font-medium leading-0',
        props.class
      )
    "
  >
    <AvatarImage
      v-if="props.image"
      class="h-full w-full rounded-[inherit] object-cover"
      :as="NuxtImg"
      :src="props.image"
      :alt="props.fallbackName"
    />
    <AvatarFallback
      class="flex h-full w-full items-center justify-center"
      :delay-ms="props.fallbackDelay"
    >
      {{ makeFallbackTitle(props.fallbackName ?? '') }}
    </AvatarFallback>
  </AvatarRoot>
</template>
